import React from 'react'
import '../styles/Editor.css'
const State = () => {
  return (
    <header className='headerEditor'><h2>State</h2></header>
  )
}

export default State